export default __webpack_public_path__ + "static/media/agingMoving.14a3c542.jpg";